import styled, { css } from 'styled-components';
import color from '../../../../../config/colors.json';

const labelStyle = css`
	font-style: normal;
	color: ${color.darkGrey5};
	font-family: 'Poppins', sans-serif;
`;

export const TooltipLabel = styled.em`
	${labelStyle};
	line-height: 17px;
	font-size: 12px;
	font-weight: normal;
`;

export const TooltipLegend = styled.span`
	display: block;
	width: 40px;
	height: 6px;
	border-radius: 50px;
	background-color: ${({ legendColor }) => (legendColor || color.darkGreyMidias)};
	margin-right: 5px;
`;

export const CaptionContainer = styled.div`
	padding: 0 40px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	> div {
		display: flex;
		align-items: center;
	}
	> em {
		${labelStyle};
		font-style: normal;
		margin-right: 30px;
		font-size: 14px;
		line-height: 20px;
	}
`;

export const Caption = styled.div`
	width: 23px;
	height: 23px;
	border-radius: 3px;
	margin-right: 13px;
	background-color: ${({ legendColor }) => (legendColor || color.darkGreyMidias)};
`;

export const CaptionLabel = styled.em`
	${labelStyle};
	margin-right: 38px;
	line-height: 21px;
	font-size: 15px;
	font-weight: normal;
`;

export const ChartDiv = styled.div`
	display: flex;
	width: 100% !important;
	@media (max-width: 1700px) {
		.recharts-responsive-container{
			width: 100% !important;
		}
	}

	.recharts-wrapper{
		width: 99% !important;
		font-size: 12px;
		display: flex;
		justify-content: space-between;
		margin: 0px auto !important;

		svg{
			width: 99% !important;
			margin: 0 -auto !important;
		}
	}
`;
